import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { OrderSummaryResponse } from '../model/ordersummaryresponse';

import { SortableColumn } from '../model/sort/sortable-column';
import { PoOrderDataServiceService } from '../../services/po-order-data-service.service';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap, tap } from 'rxjs/operators';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreMaintainenceResponse } from '../model/store-maintainence-response';
import { UserService } from 'src/app/services/user.service';
import { UserData } from '../model/user-data';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { UsersDataResponse } from '../model/users-data-response';
import { MatDialog } from '@angular/material/dialog';
import { AdvanceSearchComponent } from '../advance-search/advance-search.component';
import { AdvanceSearchDto } from "../model/advance-search-dto";
import { ApproveDialogComponent } from '../approve-dialog/approve-dialog.component';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-order-summary',
    templateUrl: './order-summary.component.html',
    styleUrls: ['./order-summary.component.scss'],
    standalone: false
})
export class OrderSummaryComponent implements OnInit,AfterViewInit {
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  orderSummary: OrderSummaryResponse[] = [];
  poSummaryForm: UntypedFormGroup;
  storeData:[]=[];
  storeNumber:string=null;
  dcNumber:number=null;
  sortableColumn:SortableColumn;
  filter:string='';
  dateTimeFormat:string='yyyy-MM-dd hh:mm:ss a';
  dateFormat:string='yyyy-MM-dd';
  constructor(private route: ActivatedRoute,private userservice:UserService,private poordersummaryservice: PoOrderDataServiceService, private fb: UntypedFormBuilder,private router:Router,private dialog:MatDialog,
    private translate: TranslateService) { 
    this.userservice.setObject('advancesearch', null);
   
  }
  displayedColumns: string[] = [];
  displayedColumnsStore: string[] = ['statusName', 'purchaseOrder', 'poPendingOrderDate', 'poReceivedDate', 'signedBy', 'action'];
  displayedColumnsDc: string[] = ['storeNum','statusName', 'purchaseOrder', 'poPendingOrderDate', 'poReceivedDate', 'signedBy', 'action'];
  dataSource: MatTableDataSource<OrderSummaryResponse>;
  userData:UserData;
  user:UsersDataResponse;
  storeNoRequired:boolean=true;
  advanceSearch:AdvanceSearchDto;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  
  ngOnInit(): void {
   
  
  this.dataSource = new MatTableDataSource<OrderSummaryResponse>();
  this.userservice.getCurrentUser().subscribe(data=>{
    this.user=data;
    this.userData=data.userData;
    this.displayedColumns=[];
    let lang=this.userData.language.toLowerCase();
    if(lang==='fr'){
      this.dateTimeFormat="medium";
     this.dateFormat="mediumDate"

    }
  
    if(this.userData.roleId<4 ){
      this.createFormDc();
      this.displayedColumns=this.displayedColumnsDc;
     
    }else{
      this.createFormStore();
      this.displayedColumns=this.displayedColumnsStore;
     
    }

    
      this.route.params.subscribe(
        (params) => 
        { 
          if(this.userData.roleId<4){
          this.dcNumber=params['dc-store-number'];
          this.storeNoRequired=false;       
         
          }else
          if(this.userData.roleId>3){
            this.storeNumber=params['dc-store-number'];
            this.storeNoRequired=true;
           
            }
            if(this.storeNumber || this.dcNumber){
              
              this.poSummaryForm.patchValue({
                storeNumber: this.storeNumber,
                dcNumber:this.dcNumber
                
              });  
           
          }

         })
          
    
   });
   
  }

  preparedAdvanceSearchInput(){
    this.advanceSearch=this.userservice.getObject("advancesearch");
    if(this.advanceSearch!==null && this.advanceSearch.purchaseOrderNumber===null){
    this.poSummaryForm.controls.storeNumber.setValue(this.advanceSearch.storeNumber);
    }
    let stats=this.advanceSearch.poStatusArray?this.advanceSearch.poStatusArray:null;

    if (stats !== null) {
      stats.forEach(s => {
        switch (s) {
          case "1":
            this.poSummaryForm.controls.poPending.setValue(true)
            break;
          case "2":
            this.poSummaryForm.controls.poOverDue.setValue(true)
            break;
          case "3":
            this.poSummaryForm.controls.poLate.setValue(true)
            break;
          case "4":
            this.poSummaryForm.controls.poSigned.setValue(true)
            break;
          case "5":
            this.poSummaryForm.controls.poReported.setValue(true)
            break;

          
        
        }
      })
    }else{
      this.poSummaryForm.controls.poPending.setValue(true);
      this.poSummaryForm.controls.poOverDue.setValue(true);
      this.poSummaryForm.controls.poLate.setValue(true);
      this.poSummaryForm.controls.poSigned.setValue(true);
      this.poSummaryForm.controls.poReported.setValue(true)
    }
    //this.poSummaryForm.controls..setValue();n
  
    this.advanceSearch.pageNo=this.paginator.pageIndex;
    this.advanceSearch.pageSize=this.paginator.pageSize;
    this.advanceSearch.order= this.sort.direction;
    this.advanceSearch.sort=this.sort.active
   
  }
  
  ngAfterViewInit() {
    this.detectScreenSize();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort=this.sort;
   
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
 
 
  merge(this.sort.sortChange, this.paginator.page)
    .pipe(    
        tap(() => this.commonSearch(0))
      )
    .subscribe();
   
    this.commonSearch(1);
 
  }

  commonSearch(result){
   // this.advanceSearch=this.userservice.getObject("advancesearch");

    if(this.advanceSearch===null || this.advanceSearch ===undefined){
      this.getPOOrderData(result);
    }else{
      this. getPOOrderWithAdvanceSearchMain(result);
    }
  }

  checkBoxStatus:boolean=false;
  checkboxChange(){
this.checkBoxStatus=true;
  }

  filterdata(result){
    this.advanceSearch=null;
    this.userservice.setObject("advancesearch",null);
    if(!this.checkBoxStatus){
    this.poSummaryForm.controls.poPending.setValue(true);
    this.poSummaryForm.controls.poOverDue.setValue(true);
    this.poSummaryForm.controls.poLate.setValue(true);
    this.poSummaryForm.controls.poSigned.setValue(false);
    this.poSummaryForm.controls.poReported.setValue(false)
    }
    this.commonSearch(result);
  }
  // getAdvanceSearchResults(result){
   
  
  //   this.getPOOrderWithAdvanceSearch(result);
  
  // }
  
  createFormDc() {
    this.poSummaryForm = this.fb.group({
      storeNumber: [''],
      dcNumber:[''],
      poPending: [true],
      poOverDue: [true],
      poLate: [true],
      poSigned: [false],
      poReported: [false]
      
    });

  }

  createFormStore() {
    this.poSummaryForm = this.fb.group({
      storeNumber: ['', Validators.required],
      dcNumber:[''],
      poPending: [true],
      poOverDue: [true],
      poLate: [true],
      poSigned: [false],
      poReported: [false]
      
    });

  }

  sortData(sort: Sort) {   
    this.sortableColumn=new SortableColumn('','','');
    const sortedData: boolean | Array<any> = this.sortableColumn.sortTableData(sort, this.dataSource.data, this.displayedColumns);    
    if (sortedData) {
      this.dataSource.data = sortedData as Array<any>;
    }
  }

  padLeft(text:string, padChar:string, size:number): string {
    return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
  }
  getPOOrderData(rest:number) {   
   
    if(rest===1)
    this.paginator.pageIndex = 0;
   
    if(this.poSummaryForm.value.storeNumber || this.poSummaryForm.value.dcNumber){
      let sn=this.poSummaryForm.controls.storeNumber.value;
      if(sn && sn.length<6){
        this.poSummaryForm.controls.storeNumber.setValue(this.padLeft(sn,'0',6));
      }
      this.dataSource=new MatTableDataSource();

    let requestPayload=this.getStatusValue();
    if(this.userData.roleId>3 || this.poSummaryForm.value.storeNumber){
      return this.poordersummaryservice!.getPOSummaryDataByStore(this.poSummaryForm.value.storeNumber,requestPayload.toString(),
        this.sort.active, this.sort.direction, this.paginator.pageIndex,this.paginator.pageSize)
        .subscribe(data =>{
          this.resultsLength = data.totalElements;
          this.dataSource=new MatTableDataSource(data.content);
          console.log(data);
        });
      }else
      if(this.userData.roleId<4 || this.poSummaryForm.value.dcNumber ){
        this.displayedColumns=[];
        this.displayedColumns=this.displayedColumnsDc;
        return this.poordersummaryservice!.getPOSummaryDataByDC(parseInt(this.poSummaryForm.value.dcNumber),requestPayload.toString(),
        this.sort.active, this.sort.direction, this.paginator.pageIndex,this.paginator.pageSize)
        .subscribe(data =>{
          this.resultsLength = data.totalElements;
          this.dataSource=new MatTableDataSource(data.content);
          console.log(data);
        });
      }     
    }
  }
  getPOOrderWithAdvanceSearch(rest:number) {   
   
    
    if(rest===1)
    this.paginator.pageIndex = 0;

    this.preparedAdvanceSearchInput();
    return this.poordersummaryservice!.advanceSearchResponse
        .subscribe(data =>{
          this.resultsLength = data.totalElements;
          this.dataSource=new MatTableDataSource(data.content);
          if(data.content.length===0){
            let dialogData= {
              title: this.userData.language==="EN"?'No Records Found':"Aucune transaction trouvée",
              message: this.userData.language==="EN"?"No records to display.":"Aucune transaction à afficher",
             
            }
            this.dialog.open(ApproveDialogComponent,{
              data:dialogData,panelClass: 'my-class'
            });
          
          }
          console.log(data);
        });
         
    
  }
  
  getPOOrderWithAdvanceSearchMain(rest:number) {   
   
    
    if(rest===1)
    this.paginator.pageIndex = 0;
    
    this.preparedAdvanceSearchInput();
    return this.poordersummaryservice!.advanceSearchMain(this.advanceSearch)
        .subscribe(data =>{
          this.resultsLength = data.totalElements;
          this.dataSource=new MatTableDataSource(data.content);
          if(data.content.length===0){
            let dialogData= {
              title: this.userData.language==="EN"?'No Records Found':"Aucune transaction trouvée",
              message: this.userData.language==="EN"?"No records to display.":"Aucune transaction à afficher",
             
            }
            this.dialog.open(ApproveDialogComponent,{
              data:dialogData,panelClass: 'my-class'
            });
          
          }
          console.log(data);
        });
         
    
  }

  getPOOrderData_OLD() {
    this.paginator.pageIndex = 0;
    if(this.poSummaryForm.value.storeNumber || this.poSummaryForm.value.dcNumber){
    this.dataSource=new MatTableDataSource();
    
    let requestPayload=this.getStatusValue();
    if(requestPayload.length>0){
    
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          if(this.userData.roleId>3 || this.poSummaryForm.value.storeNumber){
          return this.poordersummaryservice!.getPOSummaryDataByStore(this.poSummaryForm.value.storeNumber,requestPayload.toString(),
            this.sort.active, this.sort.direction, this.paginator.pageIndex,this.paginator.pageSize);
          }else
          if(this.userData.roleId<4 || this.poSummaryForm.value.dcNumber ){
            this.displayedColumns=[];
            this.displayedColumns=this.displayedColumnsDc;
            return this.poordersummaryservice!.getPOSummaryDataByDC(parseInt(this.poSummaryForm.value.dcNumber),requestPayload.toString(),
            this.sort.active, this.sort.direction, this.paginator.pageIndex,this.paginator.pageSize);
          }
          }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;

          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => {
        this.dataSource=new MatTableDataSource(data);
        this.dataSource.sort = this.sort;
    });
    }
  }
  }

 

  viewPODetails(ordersummaryresponse:OrderSummaryResponse){

    if(ordersummaryresponse.purchaseOrder.includes('RC')){
      this.router.navigate(['/dcn-esign/order-summary/receipt-confirmation',ordersummaryresponse.sequenceNumber]);
    }else{
      this.router.navigate(['/dcn-esign/order-summary/order-confirmation',ordersummaryresponse.sequenceNumber]);
      }
  }

  getStatusValue(){
    let val=[];
    let summary=this.poSummaryForm.value;
    if (summary.poPending) {
      val.push(1);
    }
    if (summary.poOverDue) {
      val.push(2);
    }
    if (summary.poLate) {
      val.push(3);
    }
    if (summary.poSigned) {
      val.push(4);
    }
    if (summary.poReported) {
      val.push(5);
    }
return val;
}

applyFilter(filterValue: string) {

  if(this.userData.roleId<4 ){
    this.dataSource.filterPredicate = function(data, filter: string): boolean {
      return data.storeNumber.toLowerCase().includes(filter) ||
       data.poStatus.toString().toLowerCase().includes(filter) ||
       data.purchaseOrder.toString().toLowerCase().includes(filter) 
       || data.poCreatedTime.toString().toLowerCase().includes(filter)
       || (data.receivedDate?data.receivedDate.toString().toLowerCase().includes(filter):('N/A').toString().toLowerCase().includes(filter))
       || (data.poSignedBy?data.poSignedBy.toString().toLowerCase().includes(filter):('').toString().toLowerCase().includes(filter))
      

}
  }else{
    this.dataSource.filterPredicate = function(data, filter: string): boolean {
    
      return data.poStatus.toString().toLowerCase().includes(filter) ||
       data.purchaseOrder.toString().toLowerCase().includes(filter) 
       || data.poCreatedTime.toString().toLowerCase().includes(filter)
       || (data.receivedDate?data.receivedDate.toString().toLowerCase().includes(filter):('N/A').toString().toLowerCase().includes(filter))
       || (data.poSignedBy?data.poSignedBy.toString().toLowerCase().includes(filter):('').toString().toLowerCase().includes(filter))
      

}
  }
  filterValue = filterValue.trim(); // Remove whitespace
  filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
  this.filter=filterValue;
  this.dataSource.filter = filterValue;
}


private detectScreenSize() {
  const height = window.innerHeight;
  const width = window.innerWidth;

  console.log(width+""+height);
}

advancedSearch(){
  this.userservice.setObject('advancesearch', null);
  
  this.dialog.open(AdvanceSearchComponent, {
  width: '640px',
  maxWidth: '95vw',
  panelClass: 'advance-search-dialog',
  data:{
    "storeNumber":this.poSummaryForm.controls.storeNumber.value 
  }
}).afterClosed().subscribe(actionName => {
  if (actionName === 'Yes') {
    // dialogRef.close();
  
    this. getPOOrderWithAdvanceSearch(1);
    
  }
});;
}

}
